// if installed from npm use 'openDB'
import { DBSchema, IDBPDatabase, openDB } from 'idb'
import { UITranscript } from '../types/transcript'
import { Ref, ref } from '@vue/composition-api'

export interface DB extends DBSchema {
  transcript: {
    key: string
    value: UITranscript | undefined
  }
}

export type DBRef = Ref<IDBPDatabase<DB>>

export function useIndexedDb() {
  async function initDB(): Promise<DBRef> {
    return ref(
      await openDB<DB>('kai-transcript', 1, {
        upgrade(database: IDBPDatabase<DB>) {
          database.createObjectStore('transcript', { autoIncrement: true })
        }
      })
    )
  }

  async function putTranscript(
    db: DBRef,
    value: UITranscript
  ): Promise<boolean> {
    if (!db.value) {
      return false
    }

    const res = await db.value.put('transcript', value, 'value')
    return !!res
  }

  async function getTranscript(db: DBRef): Promise<UITranscript | undefined> {
    if (!db.value) {
      return
    }

    return await db.value.get('transcript', 'value')
  }

  async function deleteTranscript(db: DBRef) {
    if (!db.value) {
      return
    }

    return await db.value.delete('transcript', 'value')
  }

  return {
    initDB,
    putTranscript,
    deleteTranscript,
    getTranscript
  }
}
